import client from "../api-client";
import toQueryString from "../toQueryString";

const URL = "/useronboarding.php";

export const defaultPriority = 1;

export const createTask = {
  uid: "",
  title: "",
  status: 0,
  aid: 0,
  priority: defaultPriority,
};

export const get = async (uid) => {
  let params = toQueryString({ id: uid });
  return await client(URL + `?${params}`).then(async (response) => {
    return response;
  });
};

export const markDone = async (todo) => {
  todo.status = todo.status === "1" ? 0 : 1;
  let params = toQueryString({ action: "markDone" });
  return await client(URL + `?${params}`, {
    method: "POST",
    body: todo,
  }).then(async (response) => {
    return response;
  });
};

export const add = async (task) => {
  return await client(URL, {
    method: "PUT",
    body: {
      ...createTask,
      ...task,
    },
  }).then(async (response) => {
    return response;
  });
};

export const assignUser = async (item, user) => {
  item.aid = user.aid;

  let params = toQueryString({ action: "assignUser" });

  return await client(URL + `?${params}`, {
    method: "POST",
    body: item,
  }).then(async (response) => {
    return response;
  });
};
